export default __webpack_public_path__ + "static/media/noDataAvailable.d066e9f9.svg";